import React, { ReactNode } from "react";
import { Switch, withStyles } from "@material-ui/core";

interface CommonModalProps {
    show: boolean;
    onClose: () => void;
    title?: string;
    subTitle?: string;
    children?: ReactNode;
    width?: string;
    height?: string;
    footer?: ReactNode;
    closeOnBackdropClick?: boolean;
    showToggle?: boolean;
    toggleLabel?: string;
}

/* ---------------------------------
   Custom Toggle Switch
----------------------------------*/
const CustomSwitch = withStyles({
    root: {
        width: 28,
        height: 16,
        padding: 0,
        display: "flex",
    },
    switchBase: {
        padding: 2,
        color: "#fff",
        "&$checked": {
            transform: "translateX(12px)",
            color: "#fff",
            "& + $track": {
                backgroundColor: "#E5B42F",
                opacity: 1,
                border: "none",
            },
        },
    },
    thumb: {
        width: 12,
        height: 12,
        boxShadow: "0 1px 2px rgba(0,0,0,0.3)",
    },
    track: {
        borderRadius: 8,
        border: "1px solid #ccc",
        backgroundColor: "#ccc",
        opacity: 1,
        transition: "background-color 0.3s ease",
    },
    checked: {},
})(Switch);

/* ---------------------------------
   CommonModal Component
----------------------------------*/
const CommonModal: React.FC<CommonModalProps> = ({
    show,
    onClose,
    title,
    subTitle,
    children,
    width = "500px",
    height,
    footer,
    closeOnBackdropClick = true,
    showToggle = false,
    toggleLabel = "Select ALL",
}) => {
    if (!show) return null;

    const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (closeOnBackdropClick && e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div
            onClick={handleBackdropClick}
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1100,
            }}
        >
            <div
                style={{
                    background: "#fff",
                    borderRadius: "8px",
                    padding: "25px",
                    width,
                    height,
                    position: "relative",
                    overflow: "auto",
                }}
            >
                {/* Close Button */}
                <button
                    onClick={onClose}
                    style={{
                        position: "absolute",
                        top: 8,
                        right: 20,
                        background: "none",
                        border: "none",
                        fontSize: "34px",
                        color: "#999",
                        cursor: "pointer",
                        width: "24px",
                        height: "24px"
                    }}
                >
                    ×
                </button>

                {/* Header */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "12px",
                    }}
                >
                    <div>
                        {title && (
                            <h2
                                style={{
                                    fontFamily: "Poppins, sans-serif",
                                    fontWeight: 500,
                                    fontSize: "16px",
                                    margin: 0,
                                }}
                            >
                                {title}
                            </h2>
                        )}

                        {subTitle && (
                            <p
                                style={{
                                    marginTop: "4px",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    color: "#33333380",
                                    fontFamily: "Poppins, sans-serif",
                                }}
                            >
                                {subTitle}
                            </p>
                        )}
                    </div>
                </div>

                {/* Body */}
                <div>{children}</div>

                {/* Footer */}
                {footer && <div style={{ marginTop: 20 }}>{footer}</div>}
            </div>
        </div>
    );
};

export default CommonModal;
